var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1012 10.6265C18.117 10.4197 18.125 10.2108 18.125 10C18.125 8.72986 17.8336 7.52779 17.3139 6.45702C16.283 7.43564 15.056 8.20961 13.6978 8.71384C13.7324 9.138 13.75 9.56694 13.75 10C13.75 10.9177 13.6709 11.8169 13.5191 12.6911C15.1802 12.2731 16.7265 11.566 18.1012 10.6265Z",
    fill: "#3A3F43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1953 12.9584C12.395 12.0037 12.5 11.0141 12.5 10C12.5 9.69302 12.4904 9.38828 12.4714 9.08607C11.6784 9.27499 10.8509 9.375 10 9.375C9.14913 9.375 8.32162 9.27499 7.52858 9.08607C7.50962 9.38828 7.5 9.69302 7.5 10C7.5 11.0141 7.60501 12.0037 7.80475 12.9584C8.52048 13.0681 9.2536 13.125 10 13.125C10.7464 13.125 11.4795 13.0681 12.1953 12.9584Z",
    fill: "#3A3F43"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14353 14.2659C8.75232 14.3379 9.37183 14.375 10 14.375C10.6282 14.375 11.2477 14.3379 11.8565 14.2659C11.4283 15.6456 10.7979 16.9363 10 18.1034C9.20206 16.9363 8.57168 15.6456 8.14353 14.2659Z",
    fill: "#3A3F43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48088 12.6911C6.32911 11.8169 6.25 10.9177 6.25 10C6.25 9.56694 6.26762 9.138 6.30218 8.71384C4.94405 8.20961 3.71699 7.43564 2.68611 6.45702C2.16645 7.52779 1.875 8.72986 1.875 10C1.875 10.2108 1.88303 10.4197 1.8988 10.6265C3.27355 11.566 4.81978 12.2731 6.48088 12.6911Z",
    fill: "#3A3F43"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7967 12.2938C16.9503 15.1754 14.5498 17.3922 11.5646 17.9745C12.2866 16.7603 12.8488 15.4399 13.222 14.0424C14.8552 13.7001 16.3946 13.1026 17.7967 12.2938Z",
    fill: "#3A3F43"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.20329 12.2938C3.60535 13.1026 5.14477 13.7001 6.77797 14.0424C7.15122 15.4399 7.71335 16.7603 8.43535 17.9745C5.45023 17.3922 3.0497 15.1754 2.20329 12.2938Z",
    fill: "#3A3F43"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5646 2.02553C13.666 2.43544 15.4776 3.65523 16.6614 5.34672C15.7793 6.23743 14.7198 6.95216 13.5402 7.43354C13.2184 5.48575 12.5363 3.6595 11.5646 2.02553Z",
    fill: "#3A3F43"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.89663C11.1906 3.63796 12.0081 5.65454 12.3375 7.83126C11.5903 8.02303 10.807 8.125 10 8.125C9.19296 8.125 8.40975 8.02303 7.66253 7.83126C7.99192 5.65454 8.80944 3.63796 10 1.89663Z",
    fill: "#3A3F43"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43535 2.02552C7.46373 3.6595 6.78163 5.48575 6.45976 7.43353C5.28024 6.95216 4.22074 6.23743 3.33862 5.34672C4.52241 3.65523 6.33404 2.43544 8.43535 2.02552Z",
    fill: "#3A3F43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.006a282a1fe73216a9c08e22e52a6f3b.svg";
export { ForwardRef as ReactComponent };